import { alpha } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const SELECTOR_Z_INDEX = 999;
const OPTIONS_MIN_WIDTH = 160;
const OPTION_HEIGHT = 28;

export const useProductMediaColorSelectorStyles = makeStyles()((theme) => ({
  root: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
    zIndex: SELECTOR_Z_INDEX,
  },
  toggle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.25, 0.5),
    borderRadius: theme.shape.borderRadiusFull,
    backgroundColor: alpha(theme.palette.background.paper, 0.65),
    border: `1px solid ${alpha(theme.palette.common.white, 0.8)}`,
    backdropFilter: 'blur(8px)',
    boxShadow: theme.shadows[2],
  },
  toggleIcon: {
    flexShrink: 0,
    color: theme.palette.text.primary,
  },
  options: {
    minWidth: OPTIONS_MIN_WIDTH,
    '& .MuiMenu-list': {
      padding: theme.spacing(0.5),
      gap: 0,
    },
  },
  option: {
    gap: theme.spacing(1),
    minHeight: OPTION_HEIGHT,
    padding: theme.spacing(0, 0.75),
    borderRadius: theme.shape.borderRadius,
  },
}));
